import { render, staticRenderFns } from "./ModalDeleteCriterion.vue?vue&type=template&id=2d59f507&scoped=true&"
import script from "./ModalDeleteCriterion.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteCriterion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d59f507",
  null
  
)

export default component.exports